import { Grid, styled, IconButton, useScrollTrigger } from "@mui/material";
import React, { useEffect, useState } from "react";
import { TIPOS_MENSAJES } from "../../Constants";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import DownloadIcon from "@mui/icons-material/Download";

const DocumentBubble = styled("div")(({ sent }) => ({
  backgroundColor: sent ? "#dcf8c6" : "#fff",
  padding: "6px 7px 8px 9px",
  borderRadius: "7.5px",
  maxWidth: "350px",
  position: "relative",
  boxShadow: "0 1px 0.5px rgba(0,0,0,0.13)",
  marginBottom: "10px",
  "&::before": {
    content: '""',
    position: "absolute",
    top: 0,
    width: 0,
    height: 0,
    border: "10px solid transparent",
    ...(sent
      ? {
          right: "-10px",
          borderLeftColor: "#dcf8c6",
          borderRight: 0,
          borderTop: 0,
        }
      : {
          left: "-10px",
          borderRightColor: "#fff",
          borderLeft: 0,
          borderTop: 0,
        }),
  },
}));

const DocumentContainer = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: "12px",
  cursor: "pointer",
  padding: "8px",
  "&:hover": {
    backgroundColor: "rgba(0,0,0,0.04)",
    borderRadius: "4px",
  },
});

const DocumentIcon = styled(InsertDriveFileIcon)({
  fontSize: "40px",
  color: "#5157ae",
});

const DocumentInfo = styled("div")({
  flex: 1,
  minWidth: 0,
});

const DocumentName = styled("div")({
  fontSize: "14.2px",
  color: "#303030",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
});

const DocumentMeta = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  marginTop: "4px",
});

const DocumentSize = styled("span")({
  fontSize: "11px",
  color: "rgba(0,0,0,0.45)",
});

const MessageTime = styled("span")({
  fontSize: "11px",
  color: "rgba(0,0,0,0.45)",
  display: "flex",
  alignItems: "center",
  gap: "4px",
});

const MessageTick = styled(DoneAllIcon)({
  fontSize: "16px",
  color: "#53bdeb",
});

export default function Document({
  document: documentUrl,
  tipos,
  times,
  fetchMediaUrl,
}) {
  const [documentData, setDocumentData] = useState();
  const isSent = tipos === TIPOS_MENSAJES.enviado;
  const [documentType, setDocumentType] = useState("");

  useEffect(() => {
    if (documentUrl && documentUrl.startsWith("/")) {
      setDocumentData(documentUrl);
    } else if (documentUrl) {
      fetchMediaUrl(documentUrl, setDocumentData, ".pdf");
    }
  }, [documentUrl, fetchMediaUrl]);

  const handleDocumentClick = () => {
    if (documentData) {
      window.open(documentData, "_blank");
    }
  };

  // Extract filename from URL or use a default name
  const getFileName = () => {
    if (!documentData) return "Documento";
    try {
      const url = new URL(documentData, window.location.origin);
      const pathSegments = url.pathname.split("/");
      return pathSegments[pathSegments.length - 1] || "Documento";
    } catch {
      return "Documento";
    }
  };

  return (
    <Grid
      container
      justifyContent={isSent ? "flex-end" : "flex-start"}
      sx={{ padding: "0 5%" }}
    >
      <DocumentBubble sent={isSent}>
        <DocumentContainer onClick={handleDocumentClick}>
          <DocumentIcon />
          <DocumentInfo>
            <DocumentName>{getFileName()}</DocumentName>
            <DocumentMeta>
              <DocumentSize>
                {documentUrl.split(".").pop().toUpperCase()}
              </DocumentSize>
              <MessageTime>
                {times}
                {isSent && <MessageTick />}
              </MessageTime>
              {/* Botón de descarga */}
              {documentData && (
                <a
                  href={documentData}
                  download={getFileName()}
                  style={{ marginLeft: 8, color: "#5157ae" }}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <DownloadIcon />
                </a>
              )}
            </DocumentMeta>
          </DocumentInfo>
        </DocumentContainer>
      </DocumentBubble>
    </Grid>
  );
}
